import React from "react";
import { useHistory } from "react-router-dom";
import { DataList, Link, Stack, Thumbnail } from "@tiendanube/components";
import { CameraIcon } from '@tiendanube/icons';
import { ProductResponseDto } from "../../dtos";


const { Row, Cell } = DataList;
export interface ProductRowProps {
    product: ProductResponseDto
}

function ProductRow(product: ProductRowProps) {

    const { push } = useHistory();

    const { id, name, thumbnail } = product.product;

    const goToCreateWidget = () => {
        push(`/products/${id}`);
    };

    return (
        <Row id="id" onClick={goToCreateWidget}>
            <Cell >
                <Stack justify="flex-start" align="center">
                    <Stack.Item>
                        {thumbnail &&
                            <Thumbnail
                                aspectRatio="1-1"
                                width="48px"
                                src={thumbnail}
                                altText={name}
                            />
                        }
                        {!thumbnail &&
                            <Thumbnail.Empty
                                placeholderIcon={CameraIcon}
                                aspectRatio="1-1"
                                width="48px"
                            />
                        }
                    </Stack.Item>
                    <Stack.Item >
                        <Link onClick={goToCreateWidget}
                            appearance="primary"
                        >
                            <b>{name}</b>
                        </Link>
                    </Stack.Item>
                </Stack>
            </Cell >
        </Row>
    )
}

export default ProductRow;
